var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "batsupplier--dialog",
      attrs: {
        width: "480px",
        "close-on-click-modal": false,
        visible: _vm.show,
        title: _vm.$t("stores::products-info::edit_supplier_title"),
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "supplier",
                label: _vm.$t("system::responsible::供应商"),
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "75%" },
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.form.supplier,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "supplier", $$v)
                    },
                    expression: "form.supplier",
                  },
                },
                _vm._l(_vm.list, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "batsupplier--plus",
                  on: {
                    click: function ($event) {
                      _vm.addNewModal = true
                    },
                  },
                },
                [_vm._v("+")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "72px" },
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::cancel")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "72px" },
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.setConfirm },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::save")) + " ")]
          ),
        ],
        1
      ),
      _c("edit-dialog", {
        attrs: { isNew: true, appendToBody: true },
        on: { getListData: _vm.handleAdd },
        model: {
          value: _vm.addNewModal,
          callback: function ($$v) {
            _vm.addNewModal = $$v
          },
          expression: "addNewModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }